import { RouteConfig } from 'vue-router'
import RouteEntry from '@/components/RouteEntry.vue'

export const routes = [
  {
    name: 'login',
    path: '/login',
    component: () => import('./login.vue')
  },
  {
    name: 'app',
    path: '/:app(griddiary|gridnote)',
    component: RouteEntry,
    children: [
      {
        name: 'dashboard',
        path: 'dashboard',
        component: () => import('./dashboard.vue')
      },
      {
        name: 'user',
        path: 'users',
        component: RouteEntry,
        meta: {
          breadcrumbName: 'Users'
        },
        redirect: { name: 'user.index' },
        children: [
          {
            name: 'user.index',
            path: '',
            component: () => import('./user/user-index.vue')
          },
          {
            name: 'user.new',
            path: 'new',
            component: () => import('./user/user-details.vue')
          },
          {
            name: 'user.details',
            path: ':id',
            component: () => import('./user/user-details.vue'),
            redirect: { name: 'user.details.basic' },
            children: [
              {
                name: 'user.details.basic',
                path: 'basic',
                component: () => import('./user/user-basic.vue')
              },
              {
                name: 'user.details.membership',
                path: 'membership',
                component: () => import('./user/user-membership.vue')
              },
              {
                name: 'user.details.auth',
                path: 'auth',
                component: () => import('./user/user-auth.vue')
              },
              {
                name: 'user.details.devices',
                path: 'devices',
                component: () => import('./user/user-devices.vue')
              }
            ]
          }
        ]
      },
      {
        name: 'marketing',
        path: 'marketing',
        meta: {
          breadcrumbName: 'Marketing'
        },
        component: () => import('./marketing/marketing-index.vue'),
        redirect: { name: 'marketing.campaign' },
        children: [
          {
            name: 'marketing.email',
            path: 'emails',
            component: RouteEntry,
            redirect: { name: 'marketing.email-index' },
            children: [
              {
                name: 'marketing.email-index',
                path: '',
                component: () => import('./marketing/marketing-email-index.vue')
              },
              {
                name: 'marketing.email-details',
                path: ':id',
                component: () =>
                  import('./marketing/marketing-email-details.vue')
              }
            ]
          },
          {
            name: 'marketing.appstore',
            path: 'app-store-notifications',
            component: RouteEntry,
            redirect: { name: 'marketing.appstore-index' },
            children: [
              {
                name: 'marketing.appstore-index',
                path: '',
                component: () =>
                  import(
                    './marketing/marketing-appstore-notifications-index.vue'
                  )
              },
              {
                name: 'marketing.appstore-details',
                path: ':id',
                component: () =>
                  import(
                    './marketing/marketing-appstore-notifications-index.vue'
                  )
              }
            ]
          },
          {
            name: 'marketing.campaign',
            path: 'campaigns',
            component: RouteEntry,
            redirect: { name: 'marketing.campaign-index' },
            children: [
              {
                name: 'marketing.campaign-index',
                path: '',
                component: () =>
                  import('./marketing/marketing-campaign-index.vue')
              },
              {
                name: 'marketing.campaign-details',
                path: ':id',
                component: () =>
                  import('./marketing/marketing-campaign-details.vue')
              }
            ]
          },
          {
            name: 'marketing.mailjet',
            path: 'mailjet',
            component: () => import('./marketing/marketing-mailjet.vue')
          },
          {
            name: 'marketing.intercom',
            path: 'intercom',
            component: () => import('./marketing/marketing-intercom.vue')
          }
        ]
      }
    ]
  },
  { path: '', redirect: { name: 'dashboard', params: { app: 'griddiary' } } },
  { path: '*', name: 'not-found', component: () => import('./404.vue') }
] as RouteConfig[]
